import { TabView, TabViewPanel } from '@myosh/odin-components';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import QuickLinks from '../../components/home-page/quick-links.component';
import CustomActionScroll from '../custom-actions-scroll';
import type { HomePageProps } from './home-utility';
export default function HomeMobilePage({ isLoading, alertNews, getNewsPanel }: HomePageProps) {
  const { t } = useTranslation();

  return (
    <div className="flex h-full w-full flex-col max-sm:visible sm:hidden">
      <TabView activeIndex={0} scrollable={false}>
        <TabViewPanel header={t('news')} key={'news'}>
          {!isLoading && !isEmpty(alertNews) && <div className="mb-2 flex flex-col gap-2">{alertNews}</div>}
          {getNewsPanel(true)}
        </TabViewPanel>
        <TabViewPanel header={t('quick-links')} key="quick-links">
          <QuickLinks />
        </TabViewPanel>
        <TabViewPanel header={t('my-activities')} key={'my-activities'}>
          <div className="flex h-full w-full grow flex-col gap-4 overflow-hidden pb-2">
            {<CustomActionScroll showHeader={false} />}
          </div>
        </TabViewPanel>
      </TabView>
    </div>
  );
}
